import { Directive, Renderer2, ElementRef, HostListener } from '@angular/core';
import { format } from 'rut.js';
@Directive({
  selector: '[appRutFormatter]',
})
export class RutFormatterDirective {
  rutChars = new RegExp('[,a-jA-Jl-zL-Z]', 'g');
  constructor(public renderer: Renderer2, public el: ElementRef) {}

  ngOnInit() {}

  @HostListener('input', ['$event.target.value']) onInput(e: string) {
    this.format(e);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.format(event?.clipboardData?.getData('text/plain') || '');
  }

  format(val: string) {
    let result = String(val).replace(this.rutChars, '');

    this.renderer.setProperty(this.el.nativeElement, 'value', result);
  }
}
